import { Text } from '@mantine/core';
import { brand } from '@/theme/theme';

/** Raw internal state in a mono chip on surface2, shown next to the client badge (P9). */
export function InternalStateChip({ state }: { state: string }) {
  return (
    <Text component="span" ff="monospace" fz={12} bg={brand.surface2} px={8} py={3} style={{ borderRadius: 8, border: `1px solid ${brand.border}`, whiteSpace: 'nowrap' }}>
      {state}
    </Text>
  );
}
